/* ACS Task 78: Find my size. Delegated listeners so it survives Horizon's picker re-renders. */
(function () {
  if (window.__acsFit) return;
  window.__acsFit = true;
  var ORDER = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];
  var BANDS = [140, 170, 210, 240, 270, 300]; // adjusted lb upper bounds for S..3XL, above = 4XL

  function dlg(el) { return el.closest('dialog.acs-fit') || document.querySelector('dialog.acs-fit'); }
  function data(d) {
    var s = d.querySelector('[data-acs-fit-data]');
    try { return JSON.parse(s.textContent); } catch (e) { return { shift: 0, rows: [] }; }
  }
  function available() {
    var out = [];
    document.querySelectorAll('input[data-option-name]').forEach(function (i) {
      if (i.getAttribute('data-option-name').toLowerCase() === 'size') out.push(i.value);
    });
    return out;
  }
  function pickSize(size) {
    var done = false;
    document.querySelectorAll('input[data-option-name]').forEach(function (i) {
      if (!done && i.getAttribute('data-option-name').toLowerCase() === 'size' && i.value === size) {
        i.click(); done = true;
      }
    });
    return done;
  }
  function num(form, name) { var v = parseFloat((form.elements[name] || {}).value); return isNaN(v) ? null : v; }
  function show(d, html, size) {
    var r = d.querySelector('[data-acs-result]');
    r.innerHTML = html;
    d.querySelectorAll('.acs-fit__table tr[data-size]').forEach(function (tr) {
      tr.classList.toggle('is-match', !!size && tr.getAttribute('data-size') === size);
    });
  }
  function choose(d, size, intro) {
    var avail = available();
    var ok = avail.indexOf(size) > -1;
    var html = '<p class="acs-fit__pick">' + intro + ' <strong>' + size + '</strong></p>';
    if (ok) html += '<button type="button" class="acs-fit__go" data-acs-select="' + size + '">Select size ' + size + '</button>';
    show(d, html, size);
  }

  function suggest(d, form) {
    var metric = d.getAttribute('data-units') === 'metric';
    var h, w;
    if (metric) { h = num(form, 'cm'); w = num(form, 'kg'); if (h) h = h / 2.54; if (w) w = w * 2.2046; }
    else { var ft = num(form, 'ft'), inch = num(form, 'in') || 0; h = ft ? ft * 12 + inch : null; w = num(form, 'lb'); }
    if (!h || !w || h < 48 || h > 84 || w < 70 || w > 500) {
      show(d, '<p class="acs-fit__err">Enter your height and weight to get a suggestion, or use Compare measurements.</p>');
      return;
    }
    var adj = w + (h - 68) * 2, idx = BANDS.length;
    for (var k = 0; k < BANDS.length; k++) { if (adj <= BANDS[k]) { idx = k; break; } }
    var pref = parseInt((form.querySelector('input[name=pref]:checked') || {}).value || '0', 10);
    idx += pref + (data(d).shift || 0);
    var avail = available().sort(function (a, b) { return ORDER.indexOf(a) - ORDER.indexOf(b); });
    var size = ORDER[Math.max(0, Math.min(ORDER.length - 1, idx))];
    if (avail.length && avail.indexOf(size) < 0) {
      size = idx < 0 || ORDER.indexOf(size) < ORDER.indexOf(avail[0]) ? avail[0] : avail[avail.length - 1];
    }
    choose(d, size, 'We suggest size');
  }

  function compare(d, form) {
    var metric = d.getAttribute('data-units') === 'metric';
    var w = metric ? num(form, 'wcm') : num(form, 'win');
    if (w && metric) w = w / 2.54;
    var rows = data(d).rows;
    if (!w || w < 14 || w > 36 || !rows.length) {
      show(d, '<p class="acs-fit__err">Enter the flat chest width of a shirt you own.</p>');
      return;
    }
    var best = rows[0];
    rows.forEach(function (r) { if (Math.abs(r.w - w) < Math.abs(best.w - w)) best = r; });
    choose(d, best.s, 'Closest match is size');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!(t instanceof Element)) return;
    var open = t.closest('[data-acs-fit-open]');
    if (open) {
      var d = document.querySelector('dialog.acs-fit');
      if (d && d.showModal) { d.showModal(); }
      return;
    }
    var d2 = t.closest('dialog.acs-fit');
    if (t.matches('dialog.acs-fit')) { t.close(); return; } // backdrop click
    if (!d2) return;
    if (t.closest('[data-acs-fit-close]')) { d2.close(); return; }
    var u = t.closest('[data-acs-units]');
    if (u) {
      d2.setAttribute('data-units', u.getAttribute('data-acs-units'));
      d2.querySelectorAll('[data-acs-units]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === u)); });
      return;
    }
    var tab = t.closest('[data-acs-tab]');
    if (tab) {
      var name = tab.getAttribute('data-acs-tab');
      d2.querySelectorAll('[data-acs-tab]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === tab)); });
      d2.querySelectorAll('[data-acs-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-acs-panel') !== name; });
      show(d2, '');
      return;
    }
    var sel = t.closest('[data-acs-select]');
    if (sel) { pickSize(sel.getAttribute('data-acs-select')); d2.close(); }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof Element) || !form.matches('dialog.acs-fit form[data-acs-panel]')) return;
    e.preventDefault();
    var d = dlg(form);
    if (form.getAttribute('data-acs-panel') === 'suggest') suggest(d, form); else compare(d, form);
  });
  // Thumbnail strip matches the main mockup width (the image can be narrower than its column on tall-short screens).
  function fitThumbs() {
    var s = document.querySelector('media-gallery slideshow-controls[thumbnails]');
    var m = document.querySelector('media-gallery .product-media');
    if (!s || !m) return;
    if (window.innerWidth < 750) { s.style.maxWidth = ''; s.style.marginInline = ''; return; }
    var w = m.getBoundingClientRect().width;
    if (w > 100) { s.style.maxWidth = Math.round(w) + 'px'; s.style.marginInline = 'auto'; }
  }
  window.addEventListener('resize', fitThumbs);
  window.addEventListener('load', fitThumbs);
  document.addEventListener('DOMContentLoaded', fitThumbs);
  setTimeout(fitThumbs, 400);
})();
